import qs from "qs";

import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import {
  ICreateLicenseRequestParams,
  ILicenseCalculateApproveParams,
  ILicenseCalculateParams,
  ILicenseCalculateResponse,
  ILicenseCalculateStatusResponse,
  ILicenseRecalculateParams,
  ILicenseRequestResponse,
  ILicenseRequestsListParams,
  ILicenseRequestsListResponse,
  ILicenseRequestTransitionParams,
  ILicenseRequestUpdateParams,
  IPendingLicenseRequestsParams,
} from "~/entity/Licenses/model/schema";

const licenseRequestsServiceMap = {
  root: "/license-requests",
  pending: "/license-requests/pending",
  calculate: "/license-requests/calculate",
  calculateStatus: "/license-requests/calculate/status",
  calculateApprove: "/license-requests/calculate/approve",
};

export class LicenseRequestsService {
  static _routes = licenseRequestsServiceMap;

  static GET = {
    list: (
      params?: ILicenseRequestsListParams,
    ): NetworkResponse<ILicenseRequestsListResponse> =>
      requestREST.get(licenseRequestsServiceMap.root, { params }),

    pending: (
      params?: IPendingLicenseRequestsParams,
    ): NetworkResponse<ILicenseRequestsListResponse> =>
      requestREST.get(licenseRequestsServiceMap.pending, { params }),

    byId: (id: string): NetworkResponse<ILicenseRequestResponse> =>
      requestREST.get(`${licenseRequestsServiceMap.root}/${id}`),

    calculateStatus: (
      jobId: string,
    ): NetworkResponse<ILicenseCalculateStatusResponse> =>
      requestREST.get(licenseRequestsServiceMap.calculateStatus, {
        params: { jobId },
      }),

    exportUrl: (params?: ILicenseRequestsListParams): string => {
      const filters = { ...params };
      delete filters.page;
      delete filters.count;
      const query = qs.stringify(filters, { skipNulls: true });

      return `${requestREST.defaults.baseURL}${licenseRequestsServiceMap.root}/export${
        query ? `?${query}` : ""
      }`;
    },

    exportByIdUrl: (id: string): string =>
      `${requestREST.defaults.baseURL}${licenseRequestsServiceMap.root}/${id}/export`,
  };

  static POST = {
    create: (
      data: ICreateLicenseRequestParams,
    ): NetworkResponse<ILicenseRequestResponse> =>
      requestREST.post(licenseRequestsServiceMap.root, data),

    calculate: (
      data: ILicenseCalculateParams,
    ): NetworkResponse<ILicenseCalculateResponse> =>
      requestREST.post(licenseRequestsServiceMap.calculate, data),

    approveCalculate: (
      data: ILicenseCalculateApproveParams,
    ): NetworkResponse<ILicenseCalculateResponse> =>
      requestREST.post(licenseRequestsServiceMap.calculateApprove, data),
  };

  static PUT = {
    transition: (
      id: string,
      data: ILicenseRequestTransitionParams,
    ): NetworkResponse<ILicenseRequestResponse> =>
      requestREST.put(`${licenseRequestsServiceMap.root}/${id}`, data),

    update: (
      id: string,
      data: ILicenseRequestUpdateParams,
    ): NetworkResponse<ILicenseRequestResponse> =>
      requestREST.put(`${licenseRequestsServiceMap.root}/${id}`, data),

    recalculate: (
      data: ILicenseRecalculateParams,
    ): NetworkResponse<ILicenseCalculateResponse> =>
      requestREST.put(licenseRequestsServiceMap.calculate, data),
  };
}
